import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not authed, object = authed
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api.get("/auth/me")
      .then((r) => { if (active) setUser(r.data); })
      .catch(() => { if (active) setUser(false); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const login = async (email, password) => {
    await api.post("/auth/login", { email, password });
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    // Accepts either positional legacy ({email,password,name}) or full
    // { email, password, name, phone }. Phone is optional on the backend but
    // we forward it so the registration endpoint can store it if supported.
    await api.post("/auth/register", payload);
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  const refresh = async () => {
    try { const r = await api.get("/auth/me"); setUser(r.data); return r.data; }
    catch { return null; }
  };

  const isAdmin = user && (user.role === "admin" || user.role === "super_admin");
  const isSuperAdmin = user && user.role === "super_admin";
  const permissions = (user && user.effective_permissions) || [];
  const hasPermission = (key) => isSuperAdmin || permissions.includes(key);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, isAdmin, isSuperAdmin, permissions, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
